module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAeklEQVQoU2MMXbWKmYGBgWF1WNhfEI0LMHZOnn+JgYGB4/+/Xy4V+emP8Ck8wMDAYM/AwHDv/79fjrgUM3Z0zORn4mHb+f8/gzk+xYwgq4hRDFZIjGK4QkKKURTiU4yhEJdi8hXiCgHSPUMoLIkPcEImwSIElHqIShQAsD+dsSXKZAsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right_hui.png
// module id = CF3W
// module chunks = 1